import React from 'react';
import { FaNetworkWired, FaCheckCircle, FaTimesCircle, FaExclamationTriangle } from 'react-icons/fa';
import { KavachStats } from '../utils/kavachTypes';

interface KavachStatCardsProps {
  stats: KavachStats;
}

const KavachStatCards: React.FC<KavachStatCardsProps> = ({ stats }) => {
  const cards = [
    {
      id: 'total',
      icon: <FaNetworkWired />,
      value: stats.totalSwitches,
      label: 'Total Switches',
      trend: null,
    },
    {
      id: 'up',
      icon: <FaCheckCircle />,
      value: stats.portsUp,
      label: 'Ports Up',
      trend: stats.upTrend > 0 ? `+${stats.upTrend}%` : null,
      trendType: 'up' as const,
    },
    {
      id: 'down',
      icon: <FaTimesCircle />,
      value: stats.portsDown,
      label: 'Ports Down',
      trend: stats.downTrend < 0 ? `${stats.downTrend}%` : null,
      trendType: 'down' as const,
    },
    {
      id: 'alerts',
      icon: <FaExclamationTriangle />,
      value: stats.activeAlerts,
      label: 'Active Alerts',
      trend: null,
      trendType: 'warning' as const,
    },
  ];

  return (
    <div className="dashboard-stats">
      {cards.map((card) => (
        <div key={card.id} className="stat-card">
          <div className="stat-header">
            <div className="stat-icon">{card.icon}</div>
            {card.trend && (
              <span className={`stat-trend ${card.trendType}`}>{card.trend}</span>
            )}
          </div>
          <div className="stat-value">{card.value}</div>
          <div className="stat-label">{card.label}</div>
        </div>
      ))}
    </div>
  );
};

export default KavachStatCards;
